import React from 'react';
import { Container, Col, Row, Button } from 'react-bootstrap';
import { Grid3x2GapFill, ColumnsGap } from 'react-bootstrap-icons';

import SearchToolbar from '../../../components/SearchToolbar';

export default function ISADgCollectionFilter({
	orderby,
	setOrderby,
	displaySetup,
	setDisplaySetup,
	selectedPhotos,
}) {
	return (
		<Container className='cfil'>
			<Row>
				<Col xl={11} sm={11} xs={11}>
					<SearchToolbar
						payload={{
							isLoading: selectedPhotos.isLoading,
							total: selectedPhotos.isLoading
								? '...'
								: selectedPhotos.payload?.totalResults ?? 0,
						}}
						orderby={orderby}
						setOrderby={setOrderby}
					/>
				</Col>
				<Col xl={1} sm={1} xs={1} className='lyd'>
					<Button
						variant={'light'}
						onClick={() => {
							setDisplaySetup({
								variant:
									displaySetup.variant === 'gallery'
										? 'boxes'
										: 'gallery',
							});
						}}
						className='p-0'
					>
						{displaySetup.variant === 'gallery' ? (
							<Grid3x2GapFill />
						) : (
							<ColumnsGap />
						)}
					</Button>
				</Col>
			</Row>
		</Container>
	);
}
